import config from '../config';

function normalizeStorageRelativePath(path) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  let trimmed = path.replace(/^\//, '');
  if (/^storage\//i.test(trimmed)) {
    trimmed = trimmed.slice('storage/'.length);
  }

  return trimmed || null;
}

/**
 * Public URL for a vendor logo stored on the `public` disk (e.g. vendor-logos/...).
 */
export function getVendorLogoPublicUrl(logoPath) {
  if (!logoPath || typeof logoPath !== 'string') {
    return null;
  }
  const trimmed = normalizeStorageRelativePath(logoPath);
  if (!trimmed) {
    return null;
  }
  try {
    return `${new URL(config.apiUrl).origin}/storage/${encodeURI(trimmed)}`;
  } catch {
    if (typeof window !== 'undefined') {
      return `${window.location.origin}/storage/${encodeURI(trimmed)}`;
    }
    return null;
  }
}
